import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
const CATEGORIES = [
    { color: '#F59E0B', label: 'Gold', desc: 'Ideal — high sun, cool climate' },
    { color: '#60A5FA', label: 'Silver', desc: 'Good — high sun, heat derating expected' },
    { color: '#FB923C', label: 'Moderate', desc: 'Lower potential, standard gear OK' },
    { color: '#EF4444', label: 'Poor', desc: 'Low sun + thermal stress' },
    { color: '#6B7280', label: 'Unknown', desc: 'No data available' },
];

const SolarLegend = () => {
    const map = useMap();

    useEffect(() => {
        const legend = L.control({ position: 'bottomleft' });

        legend.onAdd = () => {
            const div = L.DomUtil.create('div', 'solar-legend');
            div.innerHTML = `
                <div style="
                    background: rgba(15, 23, 42, 0.88);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255,255,255,0.1);
                    border-radius: 14px;
                    padding: 12px 16px;
                    color: #f1f5f9;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                    font-size: 12px;
                    min-width: 210px;
                    box-shadow: 0 8px 32px rgba(0,0,0,0.4);
                ">
                    <div style="font-weight:700;font-size:13px;margin-bottom:10px;display:flex;align-items:center;gap:6px;">
                        <span style="font-size:15px;">☀️</span> Solar Suitability
                    </div>
                    ${CATEGORIES.map(c => `
                        <div style="display:flex;align-items:center;gap:9px;margin-bottom:7px;">
                            <div style="
                                width:12px;height:12px;border-radius:50%;
                                background:${c.color};
                                box-shadow:0 0 6px ${c.color}88;
                                flex-shrink:0;
                            "></div>
                            <div>
                                <span style="font-weight:600;color:${c.color}">${c.label}</span>
                                <span style="color:#94a3b8;margin-left:4px;">${c.desc}</span>
                            </div>
                        </div>
                    `).join('')}
                    <div style="margin-top:10px;padding-top:8px;border-top:1px solid rgba(255,255,255,0.08);color:#64748b;font-size:10px;">
                        Data: NASA POWER API
                    </div>
                </div>`;
            return div;
        };

        legend.addTo(map);
        return () => legend.remove();
    }, [map]);

    return null;
};

export default SolarLegend;
